import React from 'react';
import { useEffect, useState } from 'react';
import Footer from '../Components/Footer';
import '../Styles/IndividualRegistrationReview.scss';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import Disclaimer from '../Components/Disclaimer';
import DateHelpers from '../Helper/DateHelpers'
import DataAccessHelper from '../Helper/DataAccessHelper';
import CamperTypeSelection from '../Components/CamperTypeSelection';
import { CombinationPageOptions } from '../Constants/RegistrationPageOptions';
import CampEventAndDateSelection from '../Components/CampEventAndDateSelection';
import GroupReservationTypeSelection from '../Components/GroupReservationTypeSelection';
import ReservationSpotSelection from '../Components/ReservationSpotSelection';
import { Helmet } from "react-helmet";
import { parseISO } from "date-fns";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../Components/CheckoutForm";

// Public Stripe Token

function IndividualRegistrationReview({ 
   guestId, camperType, setCamperType, groupJoined, 
   setGroupJoined, week, promoCode, page1Next, setPage1Next, 
   signatureData, setSignatureData, isSignatureRequired, 
   setSelectedPage, currentRegistrant, ProcessRegistration, AddToCart }) {

   const [addToCartError, setAddToCartError] = useState('')
   const [addingToCart, setAddingToCart] = useState(false)
   const [groupName, setGroupName] = useState()
   const [campFee, setCampFee] = useState()
   const [registrationFee, setRegistrationFee] = useState()
   const [reviewPaymentDue, setReviewPaymentDue] = useState()
   const [groupCodeRedeemed, setGroupCodeRedeemed] = useState('')
   const [isCCounselor, setIsCCounselor] = useState()
   const [isGroupLeader, setIsGroupLeader] = useState()
   const [isFreeDeafCamper, setIsFreeDeafCamper] = useState(false)

   const navigate = useNavigate();


   async function getReviewInformation() {
      console.log("camperType", camperType)
      console.log("week", week)
      console.log("groupJoined", groupJoined)
      console.log("promoCode", promoCode)
      console.log("singatureDate", signatureData)
      const camperBirthdate = currentRegistrant.birth_date
      console.log(camperBirthdate, "The Camper's Birthdate")
      const camperAge = await DateHelpers.determineCamperAgeInYears(camperBirthdate)
      const freeDeafCampRegistrationExists = await DataAccessHelper.searchForPreexistingFreeDeafCampRegistration(guestId)

      // Handle Group Selections
      if (groupJoined != null) {
         setGroupName(groupJoined.group_name)
         setGroupCodeRedeemed(groupJoined.group_code)
      }
      else {
         setGroupJoined({ ...groupJoined, group_id: null })
         setGroupName('Attending as Individual')
         setGroupCodeRedeemed('')
      }

      // Handle Camper Types
      if (camperType == 'Select Camper Type') {
         console.log("Camper Type is null!!")
         setCamperType(camperType = 'Camper')
         var currentCamperAge = DateHelpers.determineCamperAgeInYears(camperBirthdate)
         console.log("Current Camper Age")
      }
      else {
         if (camperType == 'Church Counselor') {
            setIsCCounselor(true)
         }
         else if (camperType == 'Group Leader') {
            setIsGroupLeader(true)
         }
      }

      // Manage Amount due
      if (week.camp_type === 'Deaf Camp') {
         setReviewPaymentDue(0)
         setCampFee(0)
         setRegistrationFee(0)
      } else {
         setReviewPaymentDue((parseFloat(week.camp_fee) + parseFloat(week.registration_fee)).toFixed(2))
         setRegistrationFee(week.registration_fee)
         setCampFee(week.camp_fee)
      }
   }


   function handlePrevious() {
      isSignatureRequired == false ?
         setSelectedPage(CombinationPageOptions.CamperType) : setSelectedPage(CombinationPageOptions.Disclaimer)
   }

   // Deaf Camp is free and has never collected payment, so it still registers directly rather than
   // taking a detour through a cart that would have nothing to charge for.
   async function handleNext(){
      if (week.camp_type === "Deaf Camp") {
         ProcessRegistration()
         return
      }
      setAddingToCart(true)
      setAddToCartError('')
      const message = await AddToCart()
      if (message) {
         setAddToCartError(message)
         setAddingToCart(false)
      }
   }

useEffect(() => {
   getReviewInformation(); 
   }, []); 

useEffect(() => {

  if(registrationFee === null || campFee === null || reviewPaymentDue === null){
   return
  }

  console.log("registrationFee:", registrationFee);
  console.log("campFee:", campFee);
  console.log("amountDue:", reviewPaymentDue);

}, [registrationFee, campFee, reviewPaymentDue]);


   return (
         <div className="IndividualRegistrationReviewContent">
            <div className="IndividualRegistrationReviewHeading">
               Review Registration Information
            </div>
            <div className="IndividualRegistrationReviewBody">
               _______________________________
               <div className="IndividualRegistrationReviewEventInformation">
                  <div className="IndividualRegistrationReviewEventInformationHeading">
                     Event Information
                  </div>
                  <div className="IndividualRegistrationReviewEventInformationContent">
                     <div className="IndividualRegistrationReviewCampName">
                        Week Selected: {week.camp_name}
                     </div>
                     <div className="IndividualRegistrationReviewCamperRole">
                        Camper Type: {camperType}
                     </div>
                     <div className="IndividualRegistrationReviewStartDate">
                        Start Date: {week.begin_date}
                     </div>
                     <div className="IndividualRegistrationReviewEndDate">
                        End Date: {week.end_date}
                     </div>
                     <div className="IndividualRegistrationReviewGroupName">
                        Group Joined: {groupName}
                     </div>
                  </div>
               </div>
               _______________________________
               <div className="IndividualRegistrationReviewCostBreakdown">
                  <div className="IndividualRegistrationReviewCostBreakdownHeading">
                     Cost Breakdown
                  </div>
                  <div className="IndividualRegistrationReviewCostBreakdownContent">
                     <div className="IndividualRegistrationReviewRegistrationFee">
                        Registration Fee:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${registrationFee}
                     </div>
                     <div className="IndividualRegistrationReviewCampFee">
                        Camp Fee:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${campFee}
                     </div>
                     <div className="IndividualRegistrationReviewTotalAmountDue">
                        Total Amount Due:&nbsp;${reviewPaymentDue}
                     </div>
                  </div>
               </div>
               _______________________________
               <div>

               </div>
            </div>
            {addToCartError &&
               <div className="IndividualRegistrationReviewError">
                  {addToCartError}
               </div>
            }
            <div className="IndividualRegistrationReviewButtons">
               <div className="IndividualRegistrationReviewPreviousButton">
                  <button onClick={() => handlePrevious()} disabled={addingToCart}>
                     Previous
                  </button>
               </div>
               <div className="IndividualRegistrationReviewNextButton">
                  <button onClick={() => handleNext()} disabled={addingToCart}>
                     {week?.camp_type === "Deaf Camp"
                        ? 'Complete Registration'
                        : addingToCart ? 'Adding…' : 'Add to Cart'}
                  </button>
               </div>
            </div>
         </div>
   )
}
export default IndividualRegistrationReview
